export default "__VITE_ASSET__860ed775__"